import { isActionLoadingSelector } from '@savgroup-front-common/core/src/domains/sagaRequestMetadata/selectors';

import { FieldServiceRootState } from '../FieldServiceRootState';

import {
  GET_ASSIGNABLE_PERMISSIONS,
  GET_CONFIGURABLE_ROLES,
  GET_MANAGEMENT_USERS,
  GET_USER_PROFILES,
} from './actionTypes';
import { DEFAULT_ENTITY_TYPE } from './constants';

export const getConfigurableRolesIsLoading = (
  state: FieldServiceRootState,
  { entityType = DEFAULT_ENTITY_TYPE } = {},
) => isActionLoadingSelector(state, GET_CONFIGURABLE_ROLES, entityType);

export const selectGetUserProfilByTenantIsLoading = (
  state: FieldServiceRootState,
  { tenantId }: { tenantId: string },
) => isActionLoadingSelector(state, GET_USER_PROFILES, tenantId);

export const getAssignablePermissionsIsLoadingSelector = (
  state: FieldServiceRootState,
) => isActionLoadingSelector(state, GET_ASSIGNABLE_PERMISSIONS);

export const getUserManagementIsLoadingSelector = (
  state: FieldServiceRootState,
  { entityType = DEFAULT_ENTITY_TYPE } = {},
) => isActionLoadingSelector(state, GET_MANAGEMENT_USERS, entityType);
